<template>
  <section class="pdf-content">
    <table width="100%" border="0" cellpadding="0" cellspacing="0">
      <tr>
        <td align="center" class="TitreFicheDenoCommune">
          <p>
            ESSAI DM <br />
            Fiche &eacute;valuation clinique
          </p>
        </td>
      </tr>
    </table>
    <p>
      <span class="EnteteN1DenoCommune"
        >D&eacute;nomination commune : {{ deno.libelle }}</span
      >
    </p>
    <table
      width="100%"
      border="0"
      cellpadding="3"
      cellspacing="3"
      class="CadreGrandTableau"
    >
      <tr>
        <td valign="top" class="TexteDenoCommune">R&eacute;f&eacute;rence :</td>
        <td valign="top" class="TexteDenoCommuneDescriptTrait">&nbsp;</td>
        <td valign="top" class="TexteDenoCommune">Fournisseur :</td>
        <td valign="top" class="TexteDenoCommuneDescriptTrait">&nbsp;</td>
      </tr>
      <tr>
        <td valign="top" class="TexteDenoCommune">Service utilisateur :</td>
        <td valign="top" class="TexteDenoCommuneDescriptTrait">&nbsp;</td>
        <td valign="top" class="TexteDenoCommune">Responsable du test :</td>
        <td valign="top" class="TexteDenoCommuneDescriptTrait">&nbsp;</td>
      </tr>
      <tr>
        <td valign="top" class="TexteDenoCommune">
          Quantit&eacute; d'&eacute;chantillons d&eacute;livr&eacute;s :
        </td>
        <td colspan="3" valign="top" class="TexteDenoCommuneDescriptTrait">
          &nbsp;
        </td>
      </tr>
      <tr>
        <td width="25%" valign="top" class="TexteDenoCommune">
          Date de d&eacute;but de test :
        </td>
        <td width="25%" valign="top" class="TexteDenoCommuneDescriptTrait">
          &nbsp;
        </td>
        <td width="25%" valign="top" class="TexteDenoCommune">
          Date de fin de test :
        </td>
        <td width="25%" valign="top" class="TexteDenoCommuneDescriptTrait">
          &nbsp;
        </td>
      </tr>
      <tr>
        <td colspan="4" valign="top" class="TexteDenoCommuneCentreTraitH">
          <span class="TexteDenoCommune"
            >1) Usage pr&eacute;cis du produit :
          </span>
        </td>
      </tr>
      <tr>
        <td
          colspan="4"
          valign="top"
          class="TexteDenoCommuneDescriptTrait"
          style="height: 5em"
        >
          &nbsp;
        </td>
      </tr>
      <tr>
        <td colspan="4" valign="top" class="TexteDenoCommuneCentreTraitH">
          <span class="TexteDenoCommune">2) Emballage : </span>
        </td>
      </tr>
      <tr>
        <td colspan="4" valign="top" class="EnteteN2DenoCommuneCentre">
          <table width="60%" border="0" cellspacing="6" cellpadding="6">
            <tr class="CadreFicheProduitImages">
              <td>&nbsp;</td>
              <td class="STitreDenoCommuneHB">
                <div align="center">Oui</div>
              </td>
              <td class="STitreDenoCommuneHB">
                <div align="center">Non</div>
              </td>
            </tr>
            <tr class="CadreFicheProduitImages">
              <td class="STitreDenoCommuneHB">Objet visible</td>
              <td class="CadreGrandTableau">&nbsp;</td>
              <td class="CadreGrandTableau">&nbsp;</td>
            </tr>
            <tr class="CadreFicheProduitImages">
              <td class="STitreDenoCommuneHB">Emballage solide</td>
              <td class="CadreGrandTableau">&nbsp;</td>
              <td class="CadreGrandTableau">&nbsp;</td>
            </tr>
            <tr class="CadreFicheProduitImages">
              <td class="STitreDenoCommuneHB">Stockage facile</td>
              <td class="CadreGrandTableau">&nbsp;</td>
              <td class="CadreGrandTableau">&nbsp;</td>
            </tr>
            <tr class="CadreFicheProduitImages">
              <td class="STitreDenoCommuneHB">Etiquetage lisible</td>
              <td class="CadreGrandTableau">&nbsp;</td>
              <td class="CadreGrandTableau">&nbsp;</td>
            </tr>
            <tr class="CadreFicheProduitImages">
              <td class="STitreDenoCommuneHB">Ouverture facile</td>
              <td class="CadreGrandTableau">&nbsp;</td>
              <td class="CadreGrandTableau">&nbsp;</td>
            </tr>
          </table>
        </td>
      </tr>
      <tr>
        <td colspan="4" valign="top" class="TexteDenoCommuneCentreTraitH">
          3) Avantages et/ou inconv&eacute;nients par rapport au produit
          utilis&eacute; :
        </td>
      </tr>
      <tr>
        <td
          colspan="4"
          valign="top"
          class="TexteDenoCommuneDescriptTrait"
          style="height: 5em"
        >
          &nbsp;
        </td>
      </tr>
      <tr>
        <td colspan="4" valign="top" class="TexteDenoCommuneCentreTraitH">
          4) Observations motivant vos crit&egrave;res d'appr&eacute;ciation :
        </td>
      </tr>
      <tr>
        <td
          colspan="4"
          valign="top"
          class="TexteDenoCommuneDescriptTrait"
          style="height: 5em"
        >
          &nbsp;
        </td>
      </tr>
      <tr>
        <td colspan="4" valign="top" class="TexteDenoCommuneCentreTraitH">
          Crit&egrave;res sp&eacute;cifiques du produit (note de 1 &agrave; 5)
        </td>
      </tr>
      <tr>
        <td colspan="4" valign="top" class="EnteteN2DenoCommuneCentre">
          <table width="60%" border="0" cellspacing="5" cellpadding="6">
            <tr class="CadreFicheProduitImages">
              <td class="CadreGrandTableau">&nbsp;</td>
              <td class="CadreGrandTableau">1</td>
              <td class="CadreGrandTableau">2</td>
              <td class="CadreGrandTableau">3</td>
              <td class="CadreGrandTableau">4</td>
              <td class="CadreGrandTableau">5</td>
            </tr>

            <tr
              class="CadreFicheProduitImagesGauche"
              v-for="(evaluation, index) in evaluations"
              :key="index"
            >
              <td class="CadreGrandTableau">{{ evaluation.intitule }}</td>
              <td class="CadreGrandTableau">&nbsp;</td>
              <td class="CadreGrandTableau">&nbsp;</td>
              <td class="CadreGrandTableau">&nbsp;</td>
              <td class="CadreGrandTableau">&nbsp;</td>
              <td class="CadreGrandTableau">&nbsp;</td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </section>
</template>

<script>
export default {
  name: "FicheEvaluation-Deno",
  props: {
    deno: {
      type: Object,
      required: true,
    },
    evaluations: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.CadreTexte {
  text-align: left;
  vertical-align: top;
  padding: 0px 0px 0px 0px;
  width: 501px;
  font-size: 70%;
  color: #000000;
  border: 1px solid #ffffff;
  font-family: Verdana, Arial, Helvetica, Sans-Serif;
  /*'Droid Sans', Arial, 'Arial Unicode MS', Helvetica, Sans-Serif;*/
  margin: 0;
  overflow: auto;
}

.TableTexte {
  font-size: 80%;
  vertical-align: top;
  border-top: 0;
  border-right: 0;
  border-bottom: 1px solid #038f88;
  border-left: 0;
  color: #025e4f;
  /**fonc�**/
}

.EnteteN1DenoCommune {
  font-size: 100%;
  font-weight: bold;
  text-align: center;
  letter-spacing: 0.1em;
  text-transform: none;
  color: #325a76;
  font-variant: small-caps;
}

.EnteteN2DenoCommune {
  font-size: 80%;
  font-weight: bold;
  text-align: left;
  text-transform: none;
  color: #325a76;
  background-color: #ffffff;
  line-height: 30px;
}

.EnteteN2DenoCommuneCentre {
  font-size: 80%;
  font-weight: bold;
  text-align: center;
  text-transform: none;
  color: #325a76;
  background-color: #ffffff;
  line-height: 30px;
}

.CadreGrandTableau {
  border: thin dotted #325a76;
  background-color: #e6edf7;
}

.CadreTableDenoCommune {
  background-color: #95befa;
}

.TitreDenoCommune {
  font-size: 100%;
  font-weight: bold;
  letter-spacing: 0.1em;
  text-align: center;
  text-transform: none;
  color: #ffffff;
  font-variant: small-caps;
  background-color: #4fb4d2;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #325a76;
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: #325a76;
  border-left-style: none;
  border-right-style: none;
}

.TitreFicheDenoCommune {
  font-size: 90%;
  font-weight: bold;
  letter-spacing: 0.1em;
  text-align: center;
  text-transform: none;
  color: #325a76;
  font-variant: small-caps;
  background-color: #eef7fc;
}

.TexteDenoCommune {
  font-size: 80%;
  font-weight: bold;
  text-align: left;
  text-transform: none;
  color: #325a76;
  background-color: #eef7fc;
  border-bottom-width: 1px;
  border-top-style: none;
  border-right-style: none;
  border-bottom-style: solid;
  border-left-style: none;
  border-bottom-color: #325a76;
}

.TexteDenoCommuneCentre {
  font-size: 80%;
  font-weight: bold;
  text-align: center;
  text-transform: none;
  color: #325a76;
  background-color: #eef7fc;
  border-bottom-width: 1px;
  border-top-style: none;
  border-right-style: none;
  border-bottom-style: solid;
  border-left-style: none;
  border-bottom-color: #325a76;
}

.TexteDenoCommuneCentreTraitH {
  font-size: 80%;
  font-weight: bold;
  text-align: center;
  text-transform: none;
  color: #325a76;
  background-color: #eef7fc;
  border-top-width: 1px;
  border-bottom-style: none;
  border-right-style: none;
  border-top-style: solid;
  border-left-style: none;
  border-top-color: #325a76;
}

.FondBleu {
  background-color: #eef7fc;
}
.CadreFicheProduitImages {
  letter-spacing: 0.1em;
  text-align: center;
  background-color: #ffffff;
  /* border: 1px solid #325a76; */
}

.CadreFicheProduitImagesGauche {
  text-align: left;
}

.STitreDenoCommune {
  font-size: 80%;
  font-weight: bold;
  text-align: left;
  text-transform: none;
  color: #325a76;
  background-color: #ffffff;
  border-top-style: solid;
  border-right-style: none;
  border-bottom-style: none;
  border-left-style: none;
  border-top-width: 1px;
  border-top-color: #325a76;
}

.STitreDenoCommuneHB {
  font-size: 80%;
  font-weight: bold;
  text-align: left;
  text-transform: none;
  color: #325a76;
  background-color: #ffffff;
  border-top-style: solid;
  border-right-style: none;
  border-bottom-style: solid;
  border-left-style: none;
  border-top-width: 1px;
  border-top-color: #325a76;
  border-bottom-width: 1px;
  border-bottom-color: #325a76;
}

.TexteDenoCommuneDescript {
  font-size: 80%;
  font-weight: normal;
  text-align: left;
  text-transform: none;
  color: #325a76;
  background-color: #ffffff;
}

.TexteDenoCommuneDescriptTrait {
  font-size: 80%;
  font-weight: normal;
  text-align: left;
  text-transform: none;
  color: #325a76;
  background-color: #ffffff;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: #325a76;
}

.TexteDenoCommuneDescriptGras {
  font-size: 80%;
  font-weight: bold;
  text-align: left;
  text-transform: none;
  color: #325a76;
  background-color: #ffffff;
}

.nettoyeur {
  clear: both;
}

.sans_gras {
  font-weight: normal;
}

.invisible {
  color: transparent;
  visibility: hidden;
}

.smaller {
  font-size: 0.9em;
}
</style>
